import React from 'react';
import { getErrorMessage } from '@/utils/form-validation/schemaHelper';

interface ErrorMessageProps {
    errors: any;
    fieldPath: string;
}

/**
 * Componente para a mensagem de erro
 * Uso: <ErrorMessage errors={errors} fieldPath="fieldPath" />
 */
const ErrorMessage: React.FC<ErrorMessageProps> = ({ errors, fieldPath }) => {
    const message = getErrorMessage(errors, fieldPath);
    if (message == null) {
        return null;
    }
    return (
        <p className="mt-2 text-sm text-red-600" data-testid={`error-${fieldPath}`}>
            {message}
        </p>
    );
};

export default ErrorMessage;